/**
 * f11.6: the review screen's read (f12.1 mounts it). The same server
 * evaluation as the grid, so the two can never disagree.
 */

import { useQuery } from '@tanstack/react-query';

import { api } from '@/api/client';
import { queryKeys } from '@/api/queryKeys';

export function useCycleValidationWarnings(
  cycleId: string,
  { businessUnitId, clientId }: { businessUnitId?: string; clientId?: string } = {},
) {
  return useQuery({
    queryKey: queryKeys.cycle.validationWarnings(cycleId, businessUnitId, clientId),
    queryFn: () => api.listCycleValidationWarnings(cycleId, { businessUnitId, clientId }),
    enabled: Boolean(cycleId),
  });
}
